// Google caps a reply at 4096 characters; we stay just under it.
export const MAX_RESPONSE_LENGTH = 4000

// Show the character count only once the limit is close enough to matter.
export const RESPONSE_LENGTH_WARNING_THRESHOLD = 100

export const REVIEWS_PAGE_SIZE = 50

// Mirrors GOOGLE_REVIEW_REPLY_BATCH_MAX_SIZE in figure-manage-api: the endpoint
// rejects a batch outside 1..50 with a 400. Deliberately independent of
// REVIEWS_PAGE_SIZE so raising the page size cannot start producing 400s.
export const SUGGESTIONS_BATCH_MAX_SIZE = 50
